import { useEffect } from "react";

import { useGetIndustryList } from "../../hooks";
import { setCachedItem } from "../../helpers";

export const useIndustryListWithCache = () => {
  const { data, isLoading, isSuccess } = useGetIndustryList();

  useEffect(() => {
    if (data && isSuccess) setCachedItem("industries", data);
  }, [data, isSuccess]);

  return { industries: data || [], isLoading, isSuccess };
};
